import React from 'react';
// import { connect } from 'react-redux';
import { ITranslateProps, translate } from '../../mixins/translate';
import { fetchGet } from '../../store/fetch';
import { formatBytes } from '../../utils/formatBytes';
// import DisplayMessage from '../utils/displayMessage';
import { NullableFormattedDate } from '../utils/NullableFormattedDate';

interface IUsageListProps extends ITranslateProps {
    id?: string;
}

interface IUsage {
    id: string;
    createdOn: Date;
    objectsCount: number;
    storageUsed: number;
}

interface IUsageListState {
    items: IUsage[];
}

class UsageList extends React.Component<IUsageListProps, IUsageListState> {
    constructor(props: IUsageListProps) {
        super(props);

        this.state = {
            items: [],
        };
    }

    public override componentDidMount() {
        void this.load(this.props.id!);
    }

    public override render() {
        return (
            <div>
                <table className="table fluid-width">
                    <thead>
                        <tr className="bg-light">
                            <th className="">{this.props.t('common.date')}</th>
                            <th className="">{this.props.t('dashboard.storageUsed')}</th>
                            <th className="">{this.props.t('common.objects')} </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.items.map((item) => (
                            <tr key={item.id}>
                                <td className="" style={{ whiteSpace: 'nowrap' }}>
                                    <NullableFormattedDate value={item.createdOn} />{' '}
                                </td>
                                <td className="" style={{ whiteSpace: 'nowrap' }}>
                                    {formatBytes(item.storageUsed)}
                                </td>
                                <td className="">{item.objectsCount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className={this.state.items.length > 0 ? 'hidden' : ''}>
                    <div className="mt40 ml10">
                        {' '}
                        <h5>{this.props.t('dashboard.noData')} </h5>
                    </div>
                </div>
            </div>
        );
    }

    private async load(companyId: string) {
        let status = 200;

        const url = `/api/companyUsages?companyId=${companyId}`;

        try {
            const response = await fetchGet(url);
            ({ status } = response);

            const { json } = response;
            if (status >= 400) {
                let code = 'DEFAULT';
                if (json && json.code) {
                    ({ code } = json);
                }
                throw new Error(code);
            }
            this.setState({ items: json.items });
        } catch (error) {
            console.error(error);
            this.setState({ items: [] });
        }
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(UsageList);
